import { TutorialText } from './TutorialText';
import { TutorialBlock } from './TutorialBlock';
import { TutorialButton } from './TutorialButton';
import { TutorialIcon } from './TutorialIcon';
import { TutorialForm } from './TutorialForm';

export const tutorialBlocks = [
  {
    name: 'Working with text',
    description: 'Shows how to edit text and change text styles',
    thumb: '',
    tags: ['Tutorial'],
    jsx: TutorialText,
  },
  {
    name: 'Background customization',
    description: 'Shows how to modify block backgrounds',
    thumb: '',
    tags: ['Tutorial'],
    jsx: TutorialBlock,
  },
  {
    name: 'Working with buttons',
    description: 'Shows how to modify button styles e.g. colors and text',
    thumb: '',
    tags: ['Tutorial'],
    jsx: TutorialButton,
  },
  {
    name: 'Working with icons',
    description: 'Shows how to edit icons and their styles',
    thumb: '',
    tags: ['Tutorial'],
    jsx: TutorialIcon,
  },
  {
    name: 'Working with forms',
    description: 'Shows how to configure forms to collect leads',
    thumb: '',
    tags: ['Tutorial'],
    jsx: TutorialForm,
  },
];



// WEBPACK FOOTER //
// ./scripts/components/editor/blocks/tutorialBlocks.js